<template>
  <div class="login-box">
    <img class="img-bj" src="@/assets/img/images/login-bj.png" />
    <div class="login-form-box">
      <p class="p1">{{ $t('register.title1') }}</p>
      <div class="tab-box">
        <!-- <div
          :class="{ sel: activeName === 'phone_register' }"
          @click="handleClick('phone_register')"
        >
          {{ $t('register.register_phone') }}
        </div> -->
        <div
          :class="{ sel: activeName === 'email_register' }"
          @click="handleClick('email_register')"
        >
          {{ $t('register.register_email') }}
        </div>
      </div>
      <el-form
        v-if="activeName === 'phone_register'"
        :model="registerForm_phone"
        :rules="rules"
        ref="ruleFormPhone"
      >
        <el-form-item :label="$t('register.phone')" prop="phoneNum">
          <el-input
            @change="phoneNumUpdate"
            v-model="registerForm_phone.phoneNum"
             :placeholder="$t('tipsVal.inputPlaceholder')"
          />
        </el-form-item>
        <el-form-item :label="$t('login.pwd')" prop="password">
          <el-input
            v-model="registerForm_phone.password"
            :type="showPassword ? '' : 'password'"
            :placeholder="$t('login.input_password')"
          >
            <template slot="suffix">
              <img
                v-if="!showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye1.png"
              />
              <img
                v-if="showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye2.png"
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('register.code')" prop="verifyCode">
          <el-input
            v-model="registerForm_phone.verifyCode"
            :placeholder="$t('register.input_code')"
          >
            <template slot="append">
              <span
                v-if="!phoneCodeStatus.hasSend"
                @click="sendPhoneCodeValidate"
                >{{ $t("register.get_code") }}</span
              >
              <span v-else>{{ phoneCodeStatus.times }}</span>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('register.invite_code')">
          <el-input
            v-model="registerForm_phone.invitedCode"
            :placeholder="$t('register.invite_code_tip')"
          />
        </el-form-item>
        <div class="title-box">
          <div>
            {{ $t('password_recovery.tip2') }}<span @click="$router.push({ path: '/login' })"
              >{{ $t('password_recovery.btn_login') }}</span
            >
          </div>
        </div>
        <el-button class="login-btn" @click="registerSend">{{ $t("register.register") }}</el-button>
        <div class="title-box mt20">
          <el-checkbox v-model="agreeFlag">{{ $t("register.agree1") }}</el-checkbox>
        </div>
      </el-form>
      <el-form v-if="activeName === 'email_register'" :model="registerForm_email" :rules="rules" ref="ruleFormEmail">
        <el-form-item :label="$t('login.email')" prop="name">
          <el-input
            v-model="registerForm_email.username"
             :placeholder="$t('tipsVal.inputPlaceholder')"
          />
        </el-form-item>
        <el-form-item :label="$t('login.pwd')" prop="password">
          <el-input
            v-model="registerForm_email.password"
            :type="showPassword ? '' : 'password'"
            :placeholder="$t('login.input_password')"
          >
            <template slot="suffix">
              <img
                v-if="!showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye1.png"
              />
              <img
                v-if="showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye2.png"
              />
            </template>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('register.code')" prop="verifyCode">
          <el-input v-model="registerForm_email.verifyCode" 
            :placeholder="$t('register.input_code')">
            <template slot="append"
              ><span
                v-if="!emailCodeStatus.hasSend"
                @click="sendEmailCodeValidate"
                >{{ $t("register.get_code") }}</span
              >
              <span v-else>{{
                emailCodeStatus.times
              }}</span></template
            >
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('register.invite_code')" prop="invitedCode">
          <el-input v-model="registerForm_email.invitedCode" :placeholder="$t('register.invite_code_tip')" />
        </el-form-item>
        <div class="title-box">
          <div>
            {{ $t('password_recovery.tip2') }}<span @click="$router.push({ path: '/login' })"
              >{{ $t('password_recovery.btn_login') }}</span
            >
          </div>
        </div>
        <el-button class="login-btn" @click="registerSend">{{ $t("register.register") }}</el-button>
        <div class="title-box mt20">
          <el-checkbox v-model="agreeFlag">{{ $t("register.agree1") }}</el-checkbox>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import bus from "@/assets/js/bus";
export default {
  name: "register",
  data() {
    let passwordConfirmValidate_phone = (rule, value, callback) => {
      let password =
        this.activeName === "phone_register"
          ? this.registerForm_phone.password
          : this.registerForm_email.password;
      if (value === "") {
        callback(new Error($t("validate.password_confirm_again")));
      } else if (value !== password) {
        callback(new Error(this.$t("validate.password_confirm_error")));
      } else {
        callback();
      }
    };
    return {
      captchaObj: null,
      challenge: null,
      agreeFlag: true,
      geetFlag: false,
      loading: false,
      showPassword: false,
      activeName: "email_register",
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      translations: {
        phoneNumberLabel: this.$t("login.input_phone"),
      },
      phoneValidateMes: {
        show: false,
        mes: "",
      },
      phoneCodeSend: {
        areacode: "",
        username: "",
        verifyType: "phone",
        challenge: null,
      },
      registerForm_phone: {
        areaCode: "",
        phoneNum: "",
        challenge: "",
        channel: "",
        invitedCode: "",
        password: "",
        passwordConfirm: "",
        registerType: "phone",
        source: "h5",
        token: "",
        username: "",
        verifyCode: "",
      },
      registerForm_email: {
        challenge: "",
        channel: "",
        invitedCode: "",
        password: "",
        passwordConfirm: "",
        registerType: "email",
        source: "h5",
        token: "",
        username: "",
        verifyCode: "",
      },
      inviteCodeDesc: "",
      rules: {
        username: [
          {
            required: true,
            message: this.$t("validate.account_require"),
            trigger: "blur",
          },
        ],
        verifyCode: [
          {
            required: true,
            message: this.$t("validate.code_require"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.password_require"),
            trigger: "blur",
          },
          {
            pattern: bus.regs.loginPWD,
            message: this.$t("validate.password_formatter_tip"),
            trigger: "blur",
          },
        ],
        passwordConfirm: [
          { validator: passwordConfirmValidate_phone, trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  created() {
    let inviteCode = this.$route.query.inviteCode;
    let account = this.$route.query.account;
    // if (/^\d+$/.test(account) || !account) {
    //   this.activeName = "phone_register";
    //   this.registerForm_phone.phoneNum = account;
    // } else {
      this.activeName = "email_register";
      this.registerForm_email.email = account;
    // }
    if (inviteCode) {
      this.registerForm_phone.invitedCode = inviteCode;
      this.registerForm_email.invitedCode = inviteCode;
    }
  },
  mounted() {
    let this_vue = this;
    this.$axios
      .post("/geetest/startCaptcha?t=" + new Date().getTime())
      .then((res) => {
        let data = res.data;
        initGeetest(
          {
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.success,
            new_captcha: true,
            product: "bind",
          },
          function (captchaObj) {
            this_vue.captchaObj = captchaObj;
            console.log(this_vue.captchaObj);
            captchaObj
              .onReady(function () {
                // $("#wait").hide();
              })
              .onSuccess(function () {
                let result = captchaObj.getValidate();
                if (!result) {
                  this_vue.$message({
                    type: "error",
                    message: this_vue.$t("validate.geet_require"),
                  });
                } else {
                  this_vue.$axios
                    .post("/geetest/verifyLogin", {
                      challenge: data.challenge,
                      geetest_challenge: result.geetest_challenge,
                      geetest_validate: result.geetest_validate,
                      geetest_seccode: result.geetest_seccode,
                    })
                    .then((res) => {
                      let flag = this_vue.activeName === "phone_register";
                      this_vue.challenge = data.challenge;
                      if (flag) {
                        this_vue.hasSendPhoneCode();
                      } else {
                        this_vue.hasSendEmailCode();
                      }
                    });
                }
              });
          },
        );
      });
  },
  methods: {
    handleClick(tab) {
      this.activeName = tab;
    },
    phoneNumUpdate(val) {
      this.phoneCodeSend.username = this.registerForm_phone.username = val;
      this.phoneCodeSend.areacode = this.registerForm_phone.areaCode = "+86";
    },
    sendPhoneCodeValidate() {
      if (this.phoneCodeSend.username.trim()) {
        this.captchaObj.verify();
      } else {
        this.$message({
          type: "error",
          message: this.$t("validate.phone_require"),
        });
      }
    },
    hasSendPhoneCode() {
      if (this.phoneCodeSend.username.trim()) {
        this.phoneCodeStatus.hasSend = true;
        let timer = setInterval(() => {
          if (this.phoneCodeStatus.times <= 0) {
            this.phoneCodeStatus.hasSend = false;
            this.phoneCodeStatus.times = 60;
            clearInterval(timer);
          } else {
            this.phoneCodeStatus.times--;
          }
        }, 1000);
        this.phoneCodeSend.challenge = this.challenge;
        this.$axios
          .post("/user/sendRegisterCode", this.phoneCodeSend)
          .then((res) => {
            if (res.data.code === this.errorCode.ok) {
              this.registerForm_phone.token = res.data.data.token;
              this.inviteCodeDesc = res.data.data.inviteDesc;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.captchaObj.reset();
          })
          .catch(() => {
            this.captchaObj.reset();
          });
      } else {
        this.$message({
          type: "error",
          message: this.$t("validate.phone_require"),
        });
      }
    },
    sendEmailCodeValidate() {
      if (this.registerForm_email.username.trim()) {
        this.captchaObj.verify();
      } else {
        this.$message({
          type: "error",
          message: this.$t("validate.email_require"),
        });
      }
    },
    hasSendEmailCode() {
      if (this.registerForm_email.username.trim()) {
        this.emailCodeStatus.hasSend = true;
        let timer = setInterval(() => {
          if (this.emailCodeStatus.times <= 0) {
            this.emailCodeStatus.hasSend = false;
            this.emailCodeStatus.times = 60;
            clearInterval(timer);
          } else {
            this.emailCodeStatus.times--;
          }
        }, 1000);
        this.$axios
          .post("/user/sendRegisterCode", {
            username: this.registerForm_email.username,
            challenge: this.challenge,
            verifyType: "email",
          })
          .then((res) => {
            if (res.data.code === this.errorCode.ok) {
              this.registerForm_email.token = res.data.data.token;
              this.inviteCodeDesc = res.data.data.inviteDesc;
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
            this.captchaObj.reset();
          })
          .catch(() => {
            this.captchaObj.reset();
          });
      } else {
        this.$message({
          type: "error",
          message: this.$t("validate.email_require"),
        });
      }
    },
    registerSend() {
      let ref = null;
      let param = null;
      let this_vue = this;
      if (this.activeName === "phone_register") {
        ref = this.$refs["ruleFormPhone"];
        param = this.registerForm_phone;
      } else {
        ref = this.$refs["ruleFormEmail"];
        param = this.registerForm_email;
      }
      ref.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          if (!this.agreeFlag) {
            this.$message({
              type: "warning",
              message: this.$t("validate.agree_require"),
            });
          } else if (this.inviteCodeDesc && !param.invitedCode) {
            this.$message({
              type: "warning",
              message: this.$t("validate.invite_code_require"),
            });
          } else {
            let param =
              this_vue.activeName === "phone_register"
                ? this_vue.registerForm_phone
                : this_vue.registerForm_email;
            param.challenge = this_vue.challenge;
            this_vue.loading = true;
            this_vue.$axios
              .post("/user/signUpWeb", param)
              .then(function (res) {
                this_vue.loading = false;
                if (res.data.code === this_vue.errorCode.ok) {
                  this_vue.$message({
                    type: "success",
                    message: this_vue.$t("alert.register_success"),
                  });
                  this_vue.$router.push({ path: "/login" });
                } else {
                  this_vue.$message({
                    type: "error",
                    message: res.data.msg,
                  });
                  this_vue.captchaObj.reset();
                }
              })
              .catch((err) => {
                this_vue.loading = false;
                this_vue.captchaObj.reset();
              });
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.login-box {
  width: 100%;
  display: flex;
  position: relative;
  background: #f5f6f7;
  justify-content: center;
  // height: calc(100% - 120px);
  /deep/ .el-form-item__label::before{
    content: '' !important;
  }
  .img-bj {
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    position: absolute;
  }
  .login-form-box {
    z-index: 2;
    width: 680px;
    margin-top: 60px;
    height: fit-content;
    position: relative;
    padding: 60px 88px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    /deep/ .el-form {
      margin-top: 40px;
    }
    .p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 40px;
      color: #333333;
    }
    .code-box {
      display: flex;
      gap: 16px;
    }
    .login-btn {
      background: #4063ff;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 32px;
    }
    .title-box {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #4063ff;
      }
    }
    /deep/.el-input-group--append {
      gap: 16px;
      display: flex;
    }
    /deep/.el-input-group__append {
      cursor: pointer;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #4063ff;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #4063ff;
      padding: 0 24px;
      width: auto;
      display: flex;
      align-items: center;
    }
    /deep/.is-checked .el-checkbox__inner {
      background: #4063ff;
    }
    /deep/.is-checked .el-checkbox__inner::after {
      width: 0;
      height: 0;
      border: none;
    }
    /deep/.el-input__inner {
      border-radius: 8px 8px 8px 8px;
    }
    /deep/.el-checkbox__inner {
      border-radius: 50%;
    }
    /deep/ .el-input__suffix,
    /deep/ .el-input__suffix-inner {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .eye-img {
      width: 25px;
      height: 25px;
      margin-right: 6px;
    }
    .tab-box {
      gap: 40px;
      display: flex;
      margin-top: 20px;
      margin-bottom: 10px;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding-bottom: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }
      .sel {
        font-weight: 800;
        font-size: 16px;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 1px solid #4063ff;
      }
    }
  }
}
</style>
